'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  inactive: 'inactive',
  active: 'active',
  loading: 'loading'
};


//////////////////
// WEBPACK FOOTER
// ./~/@dr-kobros/react-webfont-loader/lib/statuses.js
// module id = 538
// module chunks = 0